import {
  Box,
  Button
} from '@mui/material';
import {
  ActivityDetailHeaderSection,
  CustomIcons,
  appFormUtil
} from 'modules';

import { useCallback } from 'react';
import { theme } from 'theme';
import * as EditModeSection from './EditModeSection';
import * as ViewModeSection from './ViewModeSection';
import * as ds from './dataService';
import * as types from './types';



export const OrganizationSettingsActivity = () => {
  const queryTuple = ds.useQuery();
  const [fnSaveProfile] = ds.useSaveProfile();
  const form = appFormUtil.useFormState<types.IFormState>({
    initialState: {
      isEditing: false,
      profilePicture: queryTuple.data.profilePicture,
      firstName: queryTuple.data.firstName,
      lastName: queryTuple.data.lastName,
      phoneNumber: queryTuple.data.phoneNumber,
      preferredEmail: queryTuple.data.preferredEmail,
      organizationName: queryTuple.data.organizationName
    }
  });

  const {
    formState,
    dispatch
  } = form;



  const handleClickApply = useCallback(
    async () => {
      try {
        await fnSaveProfile(queryTuple.data.personId, form.formState);
        form.dispatch({
          type: 'UPDATE',
          payload: {
            property: 'isEditing',
            value: false
          }
        });

      } catch (err) {
        if (err instanceof Error) {
          alert(err.message);
        }
      }
    },
    [
      fnSaveProfile,
      form,
      queryTuple.data.personId
    ]
  );



  return (
    <>
      <ActivityDetailHeaderSection.FC
        header='Organization Settings'
        breadCrumbs={<></>}
        removeBackButton
        actions={!formState.isEditing
          ? (
            <Button
              size='small'
              onClick={() => dispatch({
                type: 'UPDATE',
                payload: {
                  property: 'isEditing',
                  value: true
                }
              })}
              startIcon={
                <CustomIcons.MediumIcon.FC stroke={theme.palette.gray.light80} icon='PENCIL' />
              }
              variant='outlined'
              color='secondary'
            >
              Edit
            </Button>
          )
          : (
            <>
              <Button
                variant='outlined'
                onClick={() => dispatch({
                  type: 'UPDATE',
                  payload: {
                    property: 'isEditing',
                    value: false
                  }
                })}
              >
                Cancel
              </Button>

              <Button
                variant='contained'
                onClick={handleClickApply}
              >
                Apply
              </Button>
            </>
          )}
      />

      <Box
        display='flex'
        flexDirection='row'
        sx={{
          rowGap: '2.5rem',
          padding: 8
        }}
      >
        {formState.isEditing
          ? (
            <EditModeSection.FC form={form} />
          )
          : (
            <ViewModeSection.FC
              dateCreated={queryTuple.data.dateCreated}
              formState={formState}
            />
          )}
      </Box>
    </>
  );
};
